export default "__VITE_ASSET__GVVfwPAA__"